var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAviso(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 333 333",
    fill: "none",
    style: {
      width: "auto",
      height: "auto"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_17_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.083 294.166C236.821 294.166 294.166 236.821 294.166 166.083C294.166 95.3447 236.821 38 166.083 38C95.3447 38 38 95.3447 38 166.083C38 236.821 95.3447 294.166 166.083 294.166Z",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 16.576
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M166.265 34C95.9757 34 39 93.2995 39 166.476C39 239.652 95.9757 298.952 166.265 298.952C236.555 298.952 293.53 239.652 293.53 166.476C293.53 93.2995 236.555 34 166.265 34ZM242.232 165.988L176.458 231.762C169.883 238.204 161.045 241.813 151.841 241.813C142.636 241.813 133.798 238.204 127.224 231.762L90.2895 194.84C83.8408 188.383 80.2198 179.63 80.2226 170.505C80.2255 161.379 83.8518 152.628 90.3046 146.175C96.7574 139.723 105.508 136.096 114.634 136.093C123.759 136.091 132.513 139.712 138.969 146.16L151.847 159.023L193.558 117.311C196.754 114.113 200.549 111.575 204.725 109.843C208.902 108.112 213.379 107.22 217.901 107.219C222.423 107.218 226.9 108.108 231.078 109.838C235.255 111.567 239.051 114.103 242.248 117.301C245.446 120.498 247.982 124.294 249.712 128.471C251.441 132.649 252.331 137.127 252.33 141.648C252.329 146.17 251.438 150.647 249.706 154.824C247.974 159.001 245.437 162.795 242.238 165.991L242.232 165.988Z",
    style: {
      fill: "rgb(231, 3, 3)",
      strokeWidth: 3.25335
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.263 123.425C232.882 121.041 230.054 119.15 226.941 117.86C223.829 116.57 220.492 115.906 217.123 115.906C213.753 115.906 210.417 116.57 207.304 117.86C204.192 119.15 201.364 121.041 198.982 123.425L157.602 164.802L132.741 189.666C130.358 192.047 128.467 194.875 127.177 197.988C125.887 201.101 125.223 204.437 125.223 207.806C125.223 211.176 125.887 214.512 127.177 217.625C128.467 220.738 130.358 223.565 132.741 225.947L133.594 226.799C135.975 229.183 138.803 231.074 141.916 232.364C145.028 233.654 148.365 234.318 151.734 234.318C155.104 234.318 158.44 233.654 161.553 232.364C164.665 231.074 167.493 229.183 169.875 226.799L185.627 211.047L236.113 160.561C238.496 158.18 240.387 155.352 241.677 152.239C242.967 149.126 243.631 145.79 243.631 142.421C243.631 139.051 242.967 135.715 241.677 132.602C240.387 129.49 238.496 126.662 236.113 124.28L235.263 123.425ZM151.841 227.982C147.83 227.983 143.91 226.795 140.575 224.568C137.24 222.341 134.64 219.175 133.104 215.47C131.568 211.766 131.166 207.689 131.947 203.756C132.728 199.822 134.658 196.209 137.493 193.372C140.328 190.536 143.94 188.604 147.873 187.82C151.806 187.037 155.883 187.437 159.589 188.97C163.294 190.504 166.462 193.102 168.69 196.436C170.919 199.769 172.11 203.689 172.111 207.699C172.11 213.076 169.975 218.233 166.174 222.036C162.373 225.839 157.218 227.978 151.841 227.982Z",
    style: {
      fill: "rgb(231, 3, 3)",
      strokeWidth: 3.25335
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_17_11",
    x: 0.111313,
    y: 0.111435,
    width: 331.943,
    height: 331.943,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.8003,
    result: "effect1_foregroundBlur_17_11"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAviso);
export default __webpack_public_path__ + "static/media/aviso.f836ec6513eb2d90648a9cda2bf3df33.svg";
export { ForwardRef as ReactComponent };